import { useFetchCallType } from '@rahtab/auth/lib/token-based-auth';
import { AlertButtonProps } from '@rahtab/ui';
import { useAlert } from '@rahtab/ui/dist/components/Alert';
import { NavigationProp, useNavigation } from '@react-navigation/native';
import { useEffect } from 'react';
import { RootStackType } from '../../Router';
import { useSelector, useAppDispatch } from 'rahtab-redux';
import { stockListSelector, setLoading } from 'rahtab-redux/slices/stockListSlice';

export const useStopStock = ({ assignFinalCode, stockCode }: StopStockArgs) => {
  const { goBack } = useNavigation<NavigationProp<RootStackType>>();
  const alert = useAlert();
  const dispatch = useAppDispatch();
  const stock = useSelector(stockListSelector(stockCode));
  const [stopStock, { called, loading, data }] = useFetchCallType<ServerResponse>('StopAssignFinallStock', {
    skip: true,
    params: `AssignFinallCode=${assignFinalCode}&StockCode=${stockCode}`,
  });
  const buttons: AlertButtonProps[] = [
    {
      color: 'secondary',
      variant: 'outlined',
      text: 'بازگشت',
      onPress: () => {
        dispatch(setLoading('refreshing'));
        goBack();
      },
    },
  ];
  useEffect(() => {
    if (!loading && data) {
      const { error, message, result } = data;
      const success = result === true;
      if (!success) buttons.pop();
      alert({
        title: 'پیام سیستم',
        message: success ? message : error,
        severity: success ? 'success' : 'error',
        hideBackButton: success,
        buttons,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loading]);
  return { stopStock, loading, called, data: stock };
};

interface StopStockArgs {
  assignFinalCode: string;
  stockCode: string;
}

interface ServerResponse {
  result: boolean;
  error: string;
  message: string;
}
